import { Component, Inject, OnInit } from '@angular/core';
import { Paginacao } from "@app/models/util/paginacao";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { TipoDeJulgamento } from '@app/models/tipo-de-julgamento.model';
import { TipoDeJulgamentoService } from '@app/services/tipo-de-julgamento.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-tipo-de-julgamento-lista',
  templateUrl: './tipo-de-julgamento-lista.component.html'
})
export class TipoDeJulgamentoListaComponent implements OnInit {

  filtroDescricao: string = "";
  bsModalRef: BsModalRef;
  paginacao: Paginacao = new Paginacao();;
  lstTipoDeJulgamento: TipoDeJulgamento[];

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private tipoDeJulgamentoService: TipoDeJulgamentoService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.tipoDeJulgamentoService.obterLista(descricao, pagina).toPromise().then(data => {
      this.lstTipoDeJulgamento = data.Dados,
        this.paginacao.totalDeItens = data.Total
    },
      erro => {
        //this.loading = false;
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  deletar(tipoDeJulgamento: TipoDeJulgamento) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir o tipo de julgamento: " + tipoDeJulgamento.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.tipoDeJulgamentoService.deletar(tipoDeJulgamento.Id).toPromise().then(
        () => {
          this.obterTodos(this.filtroDescricao, 1);
          this.paginacao.paginaAtual = 1;
        });
    };
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }
}
